import * as React from "react";
const SvgModeGoodsOut20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M1 1h18v14h-3.5l-2-2H17V9H3v4h3.5l-2 2H1V1Zm2 2v4h6V3H3Zm8 0v4h6V3h-6ZM9.293 19.207l.707.707.707-.707 3.5-3.5-1.414-1.414L11 16.086V11H9v5.086l-1.793-1.793-1.414 1.414 3.5 3.5Z",
      clipRule: "evenodd"
    })
  );
export default SvgModeGoodsOut20Px;
